const A = "/images/rooms/";

export const rooms = [
  {
    id: "si",
    name: "Αίθουσα Εργοθεραπείας (SI)",
    desc: "Πλήρως εξοπλισμένος χώρος με κούνιες, αιώρες, τοίχο αναρρίχησης, πισίνα με μπαλάκια και τσουλήθρα — εδώ τα παιδιά δυναμώνουν σώμα και αισθήσεις μέσα από το παιχνίδι.",
    color: "border-brand-yellow",
    photos: ["po4xd9fz.jpg", "8j11clyl.jpg", "dgtzniyg.jpg", "n9rrxapt.jpg"],
  },
  {
    id: "snoezelen",
    name: "Αίθουσα Snoezelen",
    desc: "Μαγικό πολυαισθητηριακό περιβάλλον με στήλες με φυσαλίδες, οπτικές ίνες και απαλά φώτα — για χαλάρωση, ηρεμία και αισθητηριακή ρύθμιση.",
    color: "border-brand-purple",
    photos: ["axsvg7do.jpg", "1pj03hch.jpg", "mym2a5sv.jpg", "2qj7ylvm.jpg", "x4ibq5zv.jpg"],
  },
  {
    id: "logotherapeia",
    name: "Αίθουσα Λογοθεραπείας",
    desc: "Ζεστός, φιλικός χώρος με παιχνίδια, βιβλία και υλικά που κάνουν κάθε συνεδρία λογοθεραπείας μια ευχάριστη εμπειρία.",
    color: "border-brand-pink",
    photos: ["avwbj67i.jpg", "4g28fc05.jpg", "zayetnz2.jpg"],
  },
  {
    id: "psychologiki",
    name: "Αίθουσα Ψυχολογικής Υποστήριξης",
    desc: "Ένας ζεστός «ασφαλής χώρος» με σκηνή-σπιτάκι, κουκλοθέατρο και δημιουργικά παιχνίδια, όπου κάθε παιδί εκφράζεται ελεύθερα.",
    color: "border-brand-blue",
    photos: ["40h6o8ac.jpg", "q31xg118.jpg"],
  },
  {
    id: "proimi",
    name: "Αίθουσα Πρώιμης Παρέμβασης",
    desc: "Ασφαλής, απαλός χώρος σχεδιασμένος για τα πιο μικρά παιδιά — με μαλακά στρώματα, τραμπολίνο και υλικά κατάλληλα για τις πρώτες τους κατακτήσεις.",
    color: "border-brand-secondary",
    photos: ["riw14k5w.jpg", "3pitmc1z.jpg", "7v1t9cf7.jpg", "w37hp24k.jpg"],
  },
  {
    id: "ypodochi",
    name: "Γραμματεία & Χώρος Αναμονής",
    desc: "Φιλόξενος χώρος υποδοχής όπου γονείς και παιδιά νιώθουν άνετα από το πρώτο λεπτό.",
    color: "border-brand-blue",
    photos: ["3q86lr4e.jpg", "hogse6yi.jpg", "z7xoz41u.jpg", "jtxgx9zb.jpg", "e814euze.jpg"],
  },
].map((r) => ({ ...r, photos: r.photos.map((p) => A + p) }));
